import { Row, Col, Container } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

const TraineeshipProgrammeTable = ({ data, size }) => {
    const { t } = useTranslation();

    // Function to format date from YYYY-MM-DD to DD-MM-YYYY
    const formatDate = (dateString) => {
      if (!dateString) return '';
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return dateString; // Return original if invalid
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      return `${day}-${month}-${year}`;
    };

    if (!data) {
        return (
            <Container>
                <Row style={{ paddingLeft: 10, paddingBottom: 15 }}>
                    <Col>
                        <Row style={{ paddingTop: 10, paddingBottom: 10 }}>
                            <Col className='text-center'>No programme data available</Col>
                        </Row>
                    </Col>
                </Row>
            </Container>
        );
    }

    return (
        <Container>
            <Row style={{ paddingLeft: 10, paddingBottom: 15 }}>
                <Col>
                    <Row style={{ paddingTop: 10, paddingBottom: 2 }}>
                        <Col className='border-hidden label-style' xs={6} sm={5} md={5}>
                            Title:
                        </Col>
                        <Col>{data?.field_tr_pre_tbl_a_title || ''}</Col>
                    </Row>
                    <Row style={{ paddingTop: 10, paddingBottom: 2 }}>
                        <Col className='border-hidden label-style' xs={6} sm={5} md={5}>
                            Start Date:
                        </Col>
                        <Col>{formatDate(data?.field_tr_pre_tbl_a_sta_period)}</Col>
                    </Row>
                    <Row style={{ paddingTop: 10, paddingBottom: 2 }}>
                        <Col className='border-hidden label-style' xs={6} sm={5} md={5}>
                            End Date:
                        </Col>
                        <Col>{formatDate(data?.field_tr_pre_tbl_a_end_period)}</Col>
                    </Row>
                    <Row style={{ paddingTop: 10, paddingBottom: 2 }}>
                        <Col className='border-hidden label-style' xs={6} sm={5} md={5}>
                            Start Date Virtual:
                        </Col>
                        <Col>{formatDate(data?.field_tr_pre_tbl_a_sta_period_v)}</Col>
                    </Row>
                    <Row style={{ paddingTop: 10, paddingBottom: 2 }}>
                        <Col className='border-hidden label-style' xs={6} sm={5} md={5}>
                            End Date Virtual:
                        </Col>
                        <Col>{formatDate(data?.field_tr_pre_tbl_a_end_period_v)}</Col>
                    </Row>
                    <Row style={{ paddingTop: 10, paddingBottom: 2 }}>
                        <Col className='border-hidden label-style' xs={6} sm={5} md={5}>
                            Working Hours per Week:
                        </Col>
                        <Col>{data?.field_tr_pre_tbl_a_whs || ''}</Col>
                    </Row>
                    <Row style={{ paddingTop: 20, paddingBottom: 10 }}>
                        <Col>
                            <hr style={{ margin: 0, borderTop: '2px solid #dee2e6' }} />
                        </Col>
                    </Row>
                    <Row style={{ paddingTop: 10, paddingBottom: 2 }}>
                        <Col className='border-hidden label-style' xs={6} sm={5} md={5}>
                            Detailed Programme of the Traineeship Period
                            {data?.field_tr_pre_tbl_a_sta_period_v && (
                                <div style={{ fontWeight: 'normal' }}>(Including the Virtual Component)</div>
                            )}
                        </Col>
                        <Col style={{ whiteSpace: 'pre-wrap' }}>{data?.field_tr_pre_tbl_a_program || ''}</Col>
                    </Row>
                    <Row style={{ paddingTop: 20, paddingBottom: 10 }}>
                        <Col>
                            <hr style={{ margin: 0, borderTop: '2px solid #dee2e6' }} />
                        </Col>
                    </Row>
                    <Row style={{ paddingTop: 10, paddingBottom: 2 }}>
                        <Col className='border-hidden label-style' xs={6} sm={5} md={5}>
                            Traineeship in Digital Skills:
                        </Col>
                        <Col>{data?.field_tr_pre_tbl_digital_skills ? 'Yes' : 'No'}</Col>
                    </Row>
                    <Row style={{ paddingTop: 20, paddingBottom: 10 }}>
                        <Col>
                            <hr style={{ margin: 0, borderTop: '2px solid #dee2e6' }} />
                        </Col>
                    </Row>
                    <Row style={{ paddingTop: 10, paddingBottom: 2 }}>
                        <Col className='border-hidden label-style' xs={6} sm={5} md={5}>
                            Knowledge, Skills & Competences to be Acquired:
                        </Col>
                        <Col>{data?.field_tr_pre_tbl_a_knowledge || ''}</Col>
                    </Row>
                    <Row style={{ paddingTop: 20, paddingBottom: 10 }}>
                        <Col>
                            <hr style={{ margin: 0, borderTop: '2px solid #dee2e6' }} />
                        </Col>
                    </Row>
                    <Row style={{ paddingTop: 10, paddingBottom: 2 }}>
                        <Col className='border-hidden label-style' xs={6} sm={5} md={5}>
                            Monitoring Plan:
                        </Col>
                        <Col>{data?.field_tr_pre_tbl_a_monitor || ''}</Col>
                    </Row>
                    <Row style={{ paddingTop: 20, paddingBottom: 10 }}>
                        <Col>
                            <hr style={{ margin: 0, borderTop: '2px solid #dee2e6' }} />
                        </Col>
                    </Row>
                    <Row style={{ paddingTop: 10, paddingBottom: 2 }}>
                        <Col className='border-hidden label-style' xs={6} sm={5} md={5}>
                            Evaluation Plan:
                        </Col>
                        <Col>{data?.field_tr_pre_tbl_a_evaluation || ''}</Col>
                    </Row>
                </Col>
            </Row>
        </Container>
    );
}

export default TraineeshipProgrammeTable;